<template>
  <div class="main-content sys-config-page" v-loading="pageLoading">
    <div class="policy-panel">
      <h3 class="policy-title">商务政策设置</h3>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="l1Content" class="policy-form-item">
          <div class="policy-row">
            <div class="policy-label">
              <span class="required">*</span>L1业绩的商务政策
            </div>
            <el-input
              v-model="form.l1Content"
              type="textarea"
              maxlength="65535"
              placeholder="请输入"
              :autosize="{ minRows: 4, maxRows: 8 }"
            />
          </div>
        </el-form-item>
        <el-form-item prop="l2Content" class="policy-form-item">
          <div class="policy-row">
            <div class="policy-label">
              <span class="required">*</span>L2业绩的商务政策
            </div>
            <el-input
              v-model="form.l2Content"
              type="textarea"
              maxlength="65535"
              placeholder="请输入"
              :autosize="{ minRows: 4, maxRows: 8 }"
            />
          </div>
        </el-form-item>
        <el-form-item class="submit-item">
          <el-button
            class="submit-btn"
            type="primary"
            :loading="submitLoading"
            @click="handleSubmit"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sysConfigList, sysConfigUpdate } from "@/api/factory/sysConfig";

export default {
  name: "FactorySysConfig",
  data() {
    const validateContent = (_, value, callback) => {
      if (!value || !String(value).trim()) {
        callback(new Error("请输入商务政策"));
        return;
      }
      callback();
    };
    return {
      pageLoading: false,
      submitLoading: false,
      configList: [],
      l1Config: null,
      l2Config: null,
      form: {
        l1Content: "",
        l2Content: "",
      },
      rules: {
        l1Content: [
          {
            required: true,
            message: "请输入L1业绩的商务政策",
            trigger: "blur",
          },
          { validator: validateContent, trigger: "blur" },
        ],
        l2Content: [
          {
            required: true,
            message: "请输入L2业绩的商务政策",
            trigger: "blur",
          },
          { validator: validateContent, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getConfigList();
  },
  methods: {
    async getConfigList() {
      this.pageLoading = true;
      try {
        const res = await sysConfigList();
        if (res.code === 200) {
          this.configList = res.data || [];
          this.l1Config = this.findConfig("L1", 0);
          this.l2Config = this.findConfig("L2", 1);
          this.form = {
            l1Content: this.l1Config ? this.l1Config.configContent || "" : "",
            l2Content: this.l2Config ? this.l2Config.configContent || "" : "",
          };
          this.$nextTick(() => {
            this.$refs.form && this.$refs.form.clearValidate();
          });
        }
      } finally {
        this.pageLoading = false;
      }
    },
    findConfig(level, fallbackIndex) {
      return (
        this.configList.find((item) =>
          String(item.configType || "")
            .toUpperCase()
            .includes(level)
        ) || this.configList[fallbackIndex]
      );
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid || this.submitLoading) return;
        if (!this.l1Config || !this.l2Config) {
          this.$message.warning("缺少商务政策配置项");
          return;
        }
        this.submitLoading = true;
        try {
          const results = await Promise.all([
            sysConfigUpdate({
              id: this.l1Config.id,
              configContent: this.form.l1Content,
            }),
            sysConfigUpdate({
              id: this.l2Config.id,
              configContent: this.form.l2Content,
            }),
          ]);
          if (results.every((res) => res.code === 200)) {
            this.$message.success("保存成功");
            this.getConfigList();
          }
        } finally {
          this.submitLoading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.sys-config-page {
  min-height: calc(100vh - 120px);
  padding: 38px 0 0 56px;
}

.policy-panel {
  width: 640px;
}

.policy-title {
  margin: 0 0 26px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #1f2d3d;
}

.policy-form-item {
  margin-bottom: 28px;
}

.policy-row {
  display: flex;
  align-items: flex-start;
}

.policy-label {
  flex: 0 0 150px;
  padding-top: 3px;
  padding-right: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #1f2d3d;
  text-align: right;
}

.required {
  margin-right: 1px;
  color: #f56c6c;
}

.policy-textarea {
  width: 360px;
}

.policy-textarea ::v-deep .el-textarea__inner {
  height: 130px;
  padding: 8px 10px;
  resize: none;
  font-size: 13px;
  line-height: 1.45;
  color: #1f2d3d;
}

.policy-form-item ::v-deep .el-form-item__content {
  line-height: 1;
}

.policy-form-item ::v-deep .el-form-item__error {
  left: 160px;
}

.submit-item {
  margin-top: 88px;
}

.submit-item ::v-deep .el-form-item__content {
  margin-left: 164px;
}

.submit-btn {
  width: 143px;
}
</style>
